import React from "react";
import { useTheme } from "../../../components/hooks/useTheme";
import { Divider } from "@mui/material";
import { validateMin } from "../../../utils/validateMin";

type Props = {
  reservationAdditionalCharges: any[];
  setReservationAdditionalCharges: (value: any[]) => void;
};

export default function ChangesAdditionalCharges({
  reservationAdditionalCharges,
  setReservationAdditionalCharges,
}: Props) {
  const { themeStyles } = useTheme();

  return (
    <div className="w-full">
      <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
        Additional Charges
      </span>

      <Divider className={`w-full ${themeStyles.divider.bg}`} />

      <div className="w-full my-3">
        <table className="min-w-full">
          <tbody className="text-left">
            <tr className={`border-b ${themeStyles.main.borderColor}`}>
              <th className={`w-[10%] text-[12px] font-semibold mb-2 pr-[1.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
              <th className={`w-[30%] text-[12px] font-semibold mb-2 px-[1.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Additional Charge</th>
              <th className={`w-[30%] text-[12px] font-semibold mb-2 px-[1.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Quantity</th>
              <th className={`w-[30%] text-[12px] font-semibold mb-2 pl-[1.25rem]  py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Base Price</th>
            </tr>

            {
              reservationAdditionalCharges?.map((item: any, index: number) => {
                return (
                  <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                    <td className="pr-[1.25rem] py-2 w-[10%]">
                      <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item.id}</span>
                    </td>

                    <td className="px-[1.25rem] py-2 w-[30%]">
                      <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.additionalChargeName}</span>
                    </td>

                    <td className="px-[1.25rem] py-2 w-[30%]">
                      <input
                        type="number"
                        min={0}
                        className={`w-full px-[5px] py-[5px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                        value={item?.quantity}
                        onChange={(e) => {
                          const updatedCharges = [...reservationAdditionalCharges];
                          updatedCharges[index] = {
                            ...updatedCharges[index],
                            quantity: validateMin(e.target.value, 0),
                          };

                          setReservationAdditionalCharges(updatedCharges);
                        }}
                      />
                    </td>

                    <td className="pl-[1.25rem] py-2 w-[30%]">
                      <input
                        type="number"
                        step="0.01"
                        className={`w-full px-[5px] py-[5px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                        value={item?.basePrice}
                        onChange={(e) => {
                          const updatedCharges = [...reservationAdditionalCharges];
                          updatedCharges[index] = {
                            ...updatedCharges[index],
                            basePrice: e.target.value
                          };

                          setReservationAdditionalCharges(updatedCharges);
                        }}
                      />
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}
